import {
	Chip,
	Option,
	Select,
} from '@material-tailwind/react';

const ChipSelector = ({setter, label, options, value }) => {
	return (
		<div className="w-full gap-6 z-10 overflow-visible">
			<Select size="md" label={label} onChange={setter} value={value}>
                {options.map((option) => {return (
                    <Option value={option.value}>
						{option.chip || 
                        <Chip value={option.label} color={option.color} variant={option.variant} size="sm" />}
                    </Option>
                )})}
			</Select>
		</div>
	);
};

export default ChipSelector;